import React from 'react';
import { Auth } from 'aws-amplify';
import { AmplifyGoogleButton } from '@aws-amplify/ui-react'
import { Card, Elevation } from "@blueprintjs/core";
import './login.scss';
import Oxygen7Logo from '../../assets/img/oxygen7-logo.png'
import Oxygen7LogoWhite from '../../assets/img/oxygen7-logo-white.png'

export const Login = () => {

  return (
    <div className="login-page">
      <img src={Oxygen7Logo} className='logo logo-color' width={300} alt='oxygen7 logo'/>
      <img src={Oxygen7LogoWhite} className='logo logo-white' width={300} alt='oxygen7 logo'/>
      <div className="login-section">
        <Card
          elevation={Elevation.TWO}
        >
          <AmplifyGoogleButton
            // Admin Portal's own Google client - an OIDC provider named
            // "GoogleAdmin" in Cognito (the built-in "Google" one is the
            // Merchant Portal's and isn't enabled on this app client).
            onClick={() => Auth.federatedSignIn({ customProvider: "GoogleAdmin" })}
          />
        </Card>

      </div>
      <footer className='footer'>
        <p>&#169; 2026 Oxygen7 PTE LTD</p>
        <a href="mailto:sales@oxygen7.io" className='contact-support'>Contact Support</a>
      </footer>
    </div>
  )
};